module.exports = "/_next/static/images/a2c246ae3ad21e00c618697fda5f4d16-hero-lg@1x.jpg.webp";